import React from 'react';
import UsaIcon from '../../usa/components/UsaIcon';
import C18Button00 from '../../usa/components/C18Button00';
import C18Input00 from '../../usa/components/C18Input00';
import {acctFeature} from '../../usa/components/C18utils'
import {wsTrans,doGetPostBasic} from '../../usa/utils/utils';
import {cl, constant,globs,getRandomString} from '../../components/utils/utils';
import C18Confirm00 from '../../usa/components/C18Confirm00'


class ShowImage extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      showBrowse:false,
      screenWidth: window.innerWidth,
      images:[],
      popup:{
        opacity:0,
        text:"Are you sure?",
        buttons:["Close"],
        resolve:null,
      },
    }
    this.subscribe_fuiImage=globs.events.subscribe("fuiImage",this.fuiImage)    
    this.subscribe_channelTypeChanged=globs.events.subscribe("channelTypeChanged",this.loadInfo)
    this.props.getValue(props.ind, {type: "local"})
    this.loadInfo()
//       <div dangerouslySetInnerHTML={{__html: this.props.custom.text}}></div>
  }
    componentDidMount() {
    // listen for window resize
    window.addEventListener("resize", this.handleResize); }
  componentWillUnmount=()=>{
    this.subscribe_fuiImage.remove()
    this.subscribe_channelTypeChanged.remove()
     window.removeEventListener("resize", this.handleResize);
  } 
   handleResize = () => {
    this.setState({ screenWidth: window.innerWidth });
  };

  fuiImage=()=>{
    cl("fuiImage")
    this.setState({showBrowse:true})
  }

  makeImageBrowse=()=>{
    cl("Upload Image")
    this.setState({showBrowse:true})
  }
  
  onChange=(type,vals)=>{
    cl(type,vals)
    switch(type){
      case "cancel":
        this.setState(vals)
        break
    }
  }
  
  makePath=(id)=>{
    return `${constant.expressUrl}/usa/images/uploads/${id[0]}/${id[1]}/${id[2]}/\
${id.substring(3)}`
  }
  
  loadInfo=async(pageType=null)=>{
//     cl(pageType)
    let pr=this.props
    let query={
      siteId:globs.userData.session.siteId,
      type:pr.type,
      zuci:pr.zuci,
    }
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/fuiImages", method: "retrieve", 
      sessionId: globs.userData.session.sessionId, body: query})
//     cl(resp)
    var path
//     cl(resp)
    if(resp.data){
//       let id=resp.data.id
//       path=`${constant.expressUrl}/usa/images/uploads/${id[0]}/${id[1]}/${id[2]}/\
// ${id.substring(3)}`
      path=this.makePath(resp.data.id)
    }else{
      // cl([pageType, pr.type, pr.fuiArray[pageType ? pageType : pr.type]])
      let imageName = pr.fuiArray[pageType ? pageType : pr.type] && pr.fuiArray[pageType ? pageType : pr.type][0]
      path=`/images/${imageName}`
    }
//     cl(path)
    this.setState({loaded:true,path:path})
    
  }
  
  showImageBrowse=()=>{
    let st=this.state
    let disp=(st.showBrowse)?"block":"none"
    return(
      <div className="image-popup" style={{
        backgroundColor:"#FFFFFF",
//         width:500,
        display:disp,
        borderRadius:10,
        padding:"0px 20px 20px 20px",
        boxShadow:"0px 4px 24px rgba(0, 0, 0, 0.16)",
        textAlign:"left",
      }}>
        <h3>Browse for Image</h3>
          <C18Button00 type="button" className="filled" aria-label="upload">
            Upload File</C18Button00>
          <C18Button00 type="button" className="filled" aria-label="upload"
            style={{marginLeft:20}}
            onClick={e=>this.onChange("cancel",{showBrowse:false})}>Cancel</C18Button00>
          <form className="file-upload-form">
          <C18Input00 id="/sidebar/growJournal/header/attach" type="file"  onChange={this.markImage} style={{
            position:"absolute", 
            width:108, 
            height:40, 
            marginTop:0, 
//            cursor:"pointer",
//             marginLeft:-41,
            zIndex:10,                   
            opacity:0,
//             cursor: "pointer",
          }}/>
          </form>
      </div>
    )
  }
  
  saveFuiImage=async(id)=>{
    cl(this.props)
    let pr=this.props
    let query={siteId:globs.userData.session.siteId,type:pr.type,zuci:pr.zuci,
      id:id
    }
    cl(query)
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/fuiImages", method: "update", 
      sessionId: globs.userData.session.sessionId, body: query})
  }
  
/****************** Image Handling *******************************/
  sendImages=async(images)=>{
    let data = new FormData()
    let base=0//this.state.gotImageCount
    for(let i=base;i<images.length;i++){
      let img=images[i]
      data.append(`id${i-base}`, img.id)
      data.append(`file${i-base}`, img.image)
      data.append('type',"fuiImage")
    }
    let url=`${constant.expressUrl}/usa/images`
    let method="POST"
    let type="multipart/form-data"
    let res=await doGetPostBasic(url, method, data, type)// pro  mise
    cl(res)
    return res
  }

  resolvePopup=(e)=>{
    //     cl(e)
        let popup=this.state.popup
        popup.opacity=0
        this.setState({popup:popup})
        // if(resolve){resolve(e)}
  }
  
  markImage=async(e)=>{
    // let images=[]
    let images=this.state.images.slice(0)
    let len0=images.length
    let imagesStr=""

    let files=e.target.files[0]
    if (!files) return
    if ((files.size > (2097152) ) || (!files.type.startsWith("image/"))) {
      // files are too powerful message
      let popup={
        opacity:1,
        text:"File must be an image and smaller than 2MB!",
        buttons:["Close"],
        resolve:e=>this.resolvePopup(e),
      }
      this.setState({popup:popup})
      this.setState({showBrowse:false})
      return
    } 
    
    for(let i=0;i<e.target.files.length;i++){
    // for(let i=e.target.files.length - 1;i>=0;i--){
      let name=e.target.files[i].name
      let ext=name.substring(name.lastIndexOf("."))
      images.push({id: getRandomString(16)+ext, image: e.target.files[i]/*e.target.files[0]*/})
      imagesStr+=`[File${len0+i+1}]`
    }
    cl(images)// images[0].id has the image id
    await this.sendImages(images)
    await this.saveFuiImage(images[images.length-1].id)
    let path=this.makePath(images[images.length-1].id)
    cl(path)
    this.setState({images: images,showBrowse:false,path:path
    })//`{Img:${expImage.id}}`
  }
/****************** End Image Handling *******************************/
  

  render(){
//     cl(this.props)
//     cl(this.state)
    const { screenWidth } = this.state;
    if(!acctFeature("equipmentImage")){return null}
    let st=this.state
    let cust=this.props.custom
    if(cust.image){
      let path=`${constant.expressUrl}/usa/images/uploads/${cust.image}`
//       cl(path)
      let className=(cust.floatRight)?"floatright":""    
    const hasFui = window.location.href.toLowerCase().includes("fui");
     const imgWidth = hasFui ? screenWidth < 550 // small screen
        ? 300  : 200  : cust.width;
      return(
        <div className={className}>
          <img id={`{"cmd":"fuiImage","type":0}`} src={st.path} width={imgWidth} onClick={this.makeImageBrowse}/> 
          {this.showImageBrowse()}
        <C18Confirm00 parms={this.state.popup}/>
        </div>
      );
    }else{
      return null
    }
  }
}

  export default ShowImage ;
